import { forwardRef, useRef, useState } from 'react'

import { Card } from '../../primitives'

import CreditCardList from './CreditCardList'
import NewCreditCardForm from './NewCreditCardForm'

import 'react-credit-cards-2/dist/es/styles-compiled.css'

const PaymentCreditCard = forwardRef((_, ref) => {
  const [showNewCreditCardForm, setshowNewCreditCardForm] = useState(false)
  const selectedCardRef = useRef<{ selectedCard: any }>()
  return (
    <Card as="div" className="" color="secondary">
      {!showNewCreditCardForm && (
        <>
          <div className="flex flex-row w-full items-center justify-between">
            <header>Meus cartões</header>
            <button className="text-gray-80 text-sm w-fit" onClick={() => setshowNewCreditCardForm(true)}>
              Novo <span className="h-2 w-0 text-gray-100">+</span>
            </button>
          </div>
          <hr className="flex items-center self-stretch divide-y divide-solid border-gray-20 mt-1" />
        </>
      )}

      {showNewCreditCardForm ? (
        <NewCreditCardForm backToCardsList={() => setshowNewCreditCardForm(false)} ref={selectedCardRef} />
      ) : (
        <CreditCardList ref={selectedCardRef} />
      )}
    </Card>
  )
})

PaymentCreditCard.displayName = 'PaymentCreditCard'

export default PaymentCreditCard
